(function() {
    'use strict';
    
a3_cabin_reports.factory('GenericModalFactory',GenericModalFactory);

    /**
    * @memberof CabinReports
    * @ngdoc factory
    * @name GenericModalFactory
    * @description 
    *    Initialize generic Modals
    * @ngInject
    */ 
function GenericModalFactory() {
		var service = {
			createNew : createNew,
			fromObject : fromObject,
			deleteFromList : deleteFromList,
			fromObjectList : fromObjectList
		}
			
        /**
         * Greate new Object  based on given constructor
         * @memberof GenericModalFactory
         * @param {function} callback A callback function that behaves as a constructor
         * @returns {object} result
         */
		function createNew(callback) {
			var result = new callback();
			result.Id = guid();
			return result;
		}

        /**
         * Extend given object 
         * @memberof GenericModalFactory
         * @param {object} obj The object that will be extended
         * @param {function} callback A callback function that behaves as a constructor
         * @returns {object} object
         */
		function fromObject(obj,callback) {
			if (obj == null) return null;
			var object = new callback();
			angular.extend(object, obj);
			return object;
		}

        /**
         * Delete an object from given List
         * @memberof GenericModalFactory
         * @param {object} obj The object that will be removed
         * @param {array} objList A list that will be modified
         * @returns {array} objList
         */
		function deleteFromList(obj, objList) {
			// find the current item in the array (if present)
			var arrayLength = objList.length;
			var itemIndex = -1;
			for (var i = 0; i < arrayLength; i++) {
				if (objList[i].Id == obj.Id) {
					itemIndex = i;
					break;
				}
			}
				
			if (itemIndex >= 0)
				objList.splice(itemIndex, 1);

			return objList;
		}
		 
        /**
         * Extend given object list
         * @memberof GenericModalFactory
         * @param {array} objList The list of objects that will be extended
         * @param {function} callback A callback function that behaves as a constructor
         * @returns {object} objList
         */
		function fromObjectList(objList,callback) {
			if (objList == null) return [];

			var arrayLength = objList.length;
			var newobjList = new Array();

			for (var i = 0; i < arrayLength; i++) {
				var obj = new callback();
				angular.extend(obj, objList[i]);
				newobjList.push(obj);
			}

			return newobjList;
		}

		return service;
	}
 
        
})();
